import React from 'react'
import ReactGA from 'react-ga'

import MyImage from '../components/Image'

const NoMatch = ({ location }) => {
  document.title = 'SunLab :: Not Found'
  ReactGA.pageview(window.location.pathname + window.location.search)
  return (
    <div>
      <h2>404 Not Found</h2>
      <hr />
      <h3 style={{ fontStyle: 'italic' }}>This is a lost wilderness. . .</h3>
      <MyImage src={require('../images/404.jpg')} height="0" width="50%" style={{ paddingBottom: '50%', margin: '0 auto', marginTop: '5em' }} mode="fill" />
    </div>
  )
}
export default NoMatch
